import React from "react";
import * as Icons from "lucide-react";
import { ICONS_BY_NAME } from "../../lib/icons";

// Une carte d'étape d'onboarding, 4 états : complétée (repliée, résumé + Modifier),
// active (dépliée, vrais champs), passée (facultative laissée vide : « À compléter
// plus tard » + Compléter, recette du 15/10), verrouillée (repliée, grise, cadenas,
// aucun champ focusable). Reprend les conventions a11y déjà
// établies dans FormCard.js (htmlFor/id, sr-only, fieldset/legend côté
// appelant pour les champs eux-mêmes).
export default function OnboardingCard({ title, description, icon, state, required, sub, onEdit, testId, children }) {
  const Icon = ICONS_BY_NAME[icon] || Icons.FileText;
  const isCompleted = state === "completed";
  const isActive = state === "active";
  const isLocked = state === "locked";
  const isSkipped = state === "skipped";

  return (
    <div
      data-testid={testId}
      data-state={state}
      className={`rounded-sm border transition-colors ${
        isActive ? "border-marine/30 bg-sable shadow-sm"
        : isCompleted ? "border-bleu/25 bg-bleu-50/40"
        : "border-marine/10 bg-sable-clair/50"
      }`}
    >
      <div className="flex items-center justify-between gap-3 p-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${
            isCompleted ? "bg-bleu text-white" : isLocked ? "bg-sable border border-marine/30 text-gris-texte" : "bg-marine/10 text-marine"
          }`}>
            {isCompleted ? <Icons.Check size={16} aria-hidden="true" /> : isLocked ? <Icons.Lock size={16} aria-hidden="true" /> : <Icon size={16} aria-hidden="true" />}
          </div>
          <div className="min-w-0">
            <div className={`text-sm font-semibold truncate ${isLocked ? "text-gris-texte" : "text-marine"}`}>
              {title} {required && !isCompleted && <span className="text-rouge" aria-hidden="true">*</span>}
            </div>
            {isActive && description && <p className="text-xs text-marine/80 mt-0.5">{description}</p>}
            {isCompleted && sub && <div className="text-xs text-bleu mt-0.5">{sub}</div>}
            {isLocked && <p className="text-xs text-gris-texte mt-0.5">Complétez l'étape précédente d'abord</p>}
            {isSkipped && <p className="text-xs text-marine/80 mt-0.5">À compléter plus tard</p>}
          </div>
        </div>
        {(isCompleted || isSkipped) && onEdit && (
          <button type="button" onClick={onEdit} data-testid={`${testId}-edit`}
            className="text-xs text-marine border border-marine/30 rounded-sm px-3 py-1.5 hover:bg-marine hover:text-white transition-colors shrink-0">
            {isSkipped ? "Compléter" : "Modifier"}
          </button>
        )}
      </div>
      {isActive && <div className="px-4 pb-4 space-y-3">{children}</div>}
    </div>
  );
}
